import { env } from "process";
import { environment } from "../environments/environment";
import { RoleEnum } from "./modules/shared/models";

// API URLs
export const API_URL = {
    GET_AUTH_TOKEN:`${environment.apiBaseUrl}/authenticate`,
    ACTIVATEDEACTIVATEUSER:`${environment.apiBaseUrl}/activateOrDeactivateUser`,
    LOGOUT:`${environment.apiBaseUrl}/logout`,
    REFRESH_TOKEN:`${environment.apiBaseUrl}/refresh`,
    PO: `${environment.apiBaseUrl}/po`,
    PO_FIELDS_HISTORY:`${environment.apiBaseUrl}/poFieldsHistory`,
    LINE_ITEM_DATA:`${environment.apiBaseUrl}/insertNewLineItem`,
    DOWNLOAD_REPORT:`${environment.apiBaseUrl}/downloadReport?po_number=`,
    DASHBOARD:`${environment.apiBaseUrl}/dashboard`,
    QESPdf:`${environment.apiBaseUrl}/downloadQESReport`,
    GET_ALL_PR: `${environment.apiBaseUrl}/getAllPRData`,//getPrcAllData
    GET_MANAGER_REPORT: `${environment.apiBaseUrl}/generateManagerReport`,
    PENDING_LINEITEM_APPROVAL: `${environment.apiBaseUrl}/pendingLineItemsApprovalFromManager`,
    CREATE_PR : `${environment.apiBaseUrl}/createPR`,//addPrcData
    CREATE_BULK_PR : `${environment.apiBaseUrl}/uploadBulkPR`,
    GET_BULK_PR_HISTORY :`${environment.apiBaseUrl}/getBulkPrTransactionHistory`, //change here
    CONVERT_TO_PR : `${environment.apiBaseUrl}/convertTranasactionToPR`,
    CLEAR_PR : `${environment.apiBaseUrl}/clearBulkTransactions`,
    GET_PR_BY_ID : `${environment.apiBaseUrl}/getPrDetailByprId`,//getPrcDataWithPrid
    SEND_EMAIL : `${environment.apiBaseUrl}/sendEmail`,
    EXPORT_PR : `${environment.apiBaseUrl}/export`,
    UPDATE_PR : `${environment.apiBaseUrl}/updatePrDetails`,//updatePrcData`,
    DELETE_PR : `${environment.apiBaseUrl}/deletePrWithPrid`,
    ARCHIVE_PR : `${environment.apiBaseUrl}/archiveOrUndoPr`,
    CHECKPOAPPROVERACKNOWLEDGMENT:`${environment.apiBaseUrl}/checkPoApproverAcknowledgement`,
    SEND_REMAINDER : `${environment.apiBaseUrl}/sendEmailReminder?`,
    GET_DATA_FOR_REMAINDER : `${environment.apiBaseUrl}/generateTemp/`,
    FETCH_BY_PLANT_DETAILS : `${environment.apiBaseUrl}/plantDetails`,
    GET_BUYER_DETAILS_by_PLANT_AND_PURCHASE_GROUP : `${environment.apiBaseUrl}/getBuyerOnPlantPgroup`,
    FETCH_BY_SERVICE_CODE : `${environment.apiBaseUrl}/getServiceMaterialDetails?material_code=`,
    FETCH_BY_SERVICE_CODE_AND_CATEGORY : `${environment.apiBaseUrl}/getServiceMasterialDetail?code=`,
    FETCH_BY_SERVICE_CODE_AND_CATEGORY_OTHER : `${environment.apiBaseUrl}/getServiceMaterialDetails?material_code=`,
    FETCH_MATERIAL_DETAILS: `${environment.apiBaseUrl}/getMaterialDetails`,
    FETCH_TAC_TARIFF_CODE: `${environment.apiBaseUrl}/getTaxTariffCode?code=`,
    FETCH_USER_INFO_BY_GID:`${environment.apiBaseUrl}/getItracerUserInfo`,
    FETCH_POHISTORY:`${environment.apiBaseUrl}/checkPoHistory`,
    FETCH_PO_CONFIRMATION_HISTORY:`${environment.apiBaseUrl}/viewPOconfirmationhistory`,
    FETCH_ALL_SUPPORTING_DOCS:`${environment.apiBaseUrl}/fethAllSupportingDocument?prId=`,
    GET_ITRACER_AUTH:`${environment.apiBaseUrl}/generateIpepAccess`,
    FIND_USER_BY_GUID:`${environment.iTracerApi}/FindUserGuid?UserGuid=`,
    DELETE_GUID: `${environment.iTracerApi}/DeleteGuidVendor`,
    GET_LINEITEM_MATERIAL_DATA:`${environment.apiBaseUrl}/getLineItems`,
    PR_UPLOAD_ATTACHMENTS: `${environment.apiBaseUrl}/prFiles`,
    FETCH_PR_FILES:`${environment.apiBaseUrl}/prFiles?prId=`,
    DOWNLAOD_PR_FILES:`${environment.apiBaseUrl}/prFiles?id=`,
    DELETE_PR_FILES:`${environment.apiBaseUrl}/removePrFile`,
    GET_PYAMENTTERMS_DESC:`${environment.apiBaseUrl}/getPaymentTermsByCode?`,
    QES_EHS_VENDORDETAILS:`${environment.apiBaseUrl}/qesEhsVendorDetailSaveOrUpdate`,
    RFQ_SELECTED_VENDOR:`${environment.apiBaseUrl}/rfqSelectedVendor`,
    QESVALIDATION_API:`${environment.apiBaseUrl}/qesValidationCheckForVendorDetails`,
    GET_SERVICE_ESN_BY_SHORT_TEXT:`${environment.apiBaseUrl}/getserviceEsnByShortText`,
    GET_VENDOR_COUNT_FOR_SINGLE_SOURCE_JUDTIFICATION:`${environment.apiBaseUrl}/rfqVendorCode`,
    QES_MATRIX:`${environment.apiBaseUrl}/qesmatrix`,
    CALCULATE_RC_TOTAL_AMOUNT:`${environment.apiBaseUrl}/calculateRcTotalAmount`,
    FETCH_BY_MATERIAL_DETAILS:`${environment.apiBaseUrl}/getMaterialDetails?`,
    FETCH_BY_VENDOR_DETAILS:  `${environment.apiBaseUrl}/getVendor?`,
    GET_QES_EHS_VENDOR_DETAILS:`${environment.apiBaseUrl}/qesGetEhsVendorDetail`,
    FETCH_DELIVER_ACK:`${environment.apiBaseUrl}/getPoDeliveryAckDetailsFromVendor?po_number=`,
    SERVICE_MATERIAL_DESC:`${environment.apiBaseUrl}/serviceMaterialMaster`,
    GL_ACCOUNT_MASTER:`${environment.apiBaseUrl}/glaccountMaster`,
    COST_CENTER_MASTER:`${environment.apiBaseUrl}/costCenterMaster`,
    GET_SERVICE_CATEGORY:`${environment.apiBaseUrl}/getServiceMasterCategory`,
    COST_CENTER_MAPPING:`${environment.apiBaseUrl}/costCenterMapping`,
    GL_ACCOUNT_MAPPING:`${environment.apiBaseUrl}/glAccountMapping`,
    FETCH_MAPPED_COST_CENTER:`${environment.apiBaseUrl}/costCenterMapping?id=`,
    FETCH_MAPPED_GL_ACCOUNTS:`${environment.apiBaseUrl}/glAccountMapping?id=`,
    REPORTING_MANAGER_DETAIL_MASTERDATA:`${environment.apiBaseUrl}/reportingManagerDetails`,
    UPDATE_QUOTATION_DEADLINES:`${environment.apiBaseUrl}/updateQutoationDeadline`,
    PR_HISTORY:`${environment.apiBaseUrl}/getPrHistory?prId=`,
    UPDATE_RFQ_REMARKS:`${environment.apiBaseUrl}/updateRfqRemark`,
    GET_AUDIT_REPORT:`${environment.apiBaseUrl}/auditReports`,
    ACCEPT_DECLINE_SUPPLIER_QUOTATION:`${environment.apiBaseUrl}/supplierAcceptOrRejectQuotation`,
    FETCH_PR_APPROVER_DETAILS:`${environment.apiBaseUrl}/fetchPRApprovalManagerDetails`,
    APPROVE_REJECT_PR:`${environment.apiBaseUrl}/prApprovalByManager`,
    FIND_TEMPLATE_ID:`${environment.apiBaseUrl}/getUnRegisteredTemplate?id=`,
    GET_UNREGISTERED_VENDOR_NEGOTIATION:`${environment.apiBaseUrl}/getNegotiationForSupplier?`,
    POST_ONBOARD:`${environment.apiBaseUrl}/convertUnRegisteredVendorToRegistered`,
    PR_APPROVAL_BY_MANAGER:`${environment.apiBaseUrl}/prApprovalByManager`,
    CLOSE_PR:`${environment.apiBaseUrl}/archiveOrUndoPr`,
    UPLOAD_NEW_LINEITEM_DOCS:`${environment.apiBaseUrl}/uploadNewLineItemDocuments`,
    DOWNLOAD_LINE_ITEMS_TEMPLATE:`${environment.apiBaseUrl}/download_line_item_Details`,
    UPLOAD_BULK_LINE_ITEMS:`${environment.apiBaseUrl}/bulkUpdateLineItems`,

    // vendor=${vendor_code}&purchase_org=${purchase_org}`,
    PERMISSIONS: {
        GET_PAGE_ACCESS: `${environment.apiBaseUrl}/allpages`,
        SAVE_PAGE_ACCESS: `${environment.apiBaseUrl}/create-page`,
        DELETE_PAGE_ACCESS: `${environment.apiBaseUrl}/delete/page/`,
    },
    LINE_ITEM : {
        DELETE : `${environment.apiBaseUrl}/deletePrLineItem`,//deleteLineItemPrc`,
        ADD : `${environment.apiBaseUrl}/insertNewLineItem`,//insertLineItemPrc
    },
    APPROVE_REJECT_CLARIFICATION: `${environment.apiBaseUrl}/update_pr_status`,
    APPROVE_REJECT_ANALYSE: `${environment.apiBaseUrl}/sendForFPApproval`,
    SUPPLIER : {
        RFQ : {
            FETCH_QUOTATIONS : `${environment.apiBaseUrl}/getAllQuotatations`,
            UPDATE_QUOTATION : `${environment.apiBaseUrl}/updateQuotationBySupplier`,
            UPLOAD_ATTACHMENT: `${environment.apiBaseUrl}/rfq_attachement?rfqId=`,
            GET_NEGOTIATION_DETAILS_BY_SUPPLIER:`${environment.apiBaseUrl}/getNegotiationDetailsBySupplier`,
            UNREGISTERED_QUOTATION:`${environment.apiBaseUrl}/updateQuotationBySupplier`,
        },
        PO_CONFIRMATION : {
            FETCH_PO_CONFIRMATION : `${environment.apiBaseUrl}/getPoConfirmationDetails?status=`,
            GET_PO_CONFIRMATION : `${environment.apiBaseUrl}/getPoConfirmationDetails?po_number=`,
            GET_SCHEDULE_ITEMS_DATA:`${environment.apiBaseUrl}/getPoScheduleItems?po_number=`,
            CONFIRM_PO:`${environment.apiBaseUrl}/poConfirmationAckFormVendor`,
            DOWNLOAD_FILE:`${environment.apiBaseUrl}/getPoConfirmationFile?confirmationId=`
        }
    },
    BUYER: {
        FETCH_BUYERS: `${environment.apiBaseUrl}/fetchAllBuyer`,
        GET_ALL_PR : `${environment.apiBaseUrl}/getPrcbuyerData`,
        BUYER_SPECIFIC_PRS : `${environment.apiBaseUrl}/user_specific_prs`,
        BUYER_SPECIFIC_MY_PRS : `${environment.apiBaseUrl}/user_specific_prs?status=`,
        BUYER_SPECIFIC_PO_PRS : `${environment.apiBaseUrl}/user_specific_prs?status=PO_CREATED`,
        BUYER_SPECIFIC_MRP_PRS : `${environment.apiBaseUrl}/user_specific_prs?status=MRP`, 
        // PR_MATERIAL_MASTER: `${environment.apiBaseUrl}/view/pr_material_master/`,
        RCGET : `${environment.apiBaseUrl}/buyer-contract`,
        ASSIGN_TO_BUYER : `${environment.apiBaseUrl}/assign_to_buyer`,
        ASSIGN_TO_MYSELF : `${environment.apiBaseUrl}/assign-buyer-myself?`,
        PPC_RESULT: `${environment.apiBaseUrl}/info_records?`,
        VALIDATE_PRICE_PPC:`${environment.apiBaseUrl}/validate_info_records`,
        FORWARD_PR: `${environment.apiBaseUrl}/forwardPr`,
        FORWARD_PR_TO_BUYER: `${environment.apiBaseUrl}/assignedPrForToAnotherBuyer`,
        PR_ASSIGNED_TO_ANOTHER_MANAGER:`${environment.apiBaseUrl}/prAssignedToAnotherManager`,
        // FORWARD_LINEITEM: `${environment.apiBaseUrl}/forwardLineItem/`,
        GET_ALL_REPORT:`${environment.apiBaseUrl}/allReportForBuyer`,
        GET_ALL_UNREGISTER_VENDOR:`${environment.apiBaseUrl}/getAllRFQwithData?isRegVendor=`,
        MARKET_RESULT : {
            FETCH_RESULT : `${environment.apiBaseUrl}/supplier_market_assessment`,
            FETCH_VENDOR : `${environment.apiBaseUrl}/fetch-vendor-details?vendor=`,
            ADD_VENDOR : `${environment.apiBaseUrl}/fetch-vendor-details`
        },
        AUTO_PO : `${environment.apiBaseUrl}/createPO`,
        GET_TAX_CODE : `${environment.apiBaseUrl}/taxcode`,
        RUN_MRP: `${environment.apiBaseUrl}/mrp_run?`,
        GET_MRP_FORMDATA: `${environment.apiBaseUrl}/mrpFormData`,
        GET_MRP_PRS: `${environment.apiBaseUrl}/getMrpOpenPR`,
        IMPORT_PR: `${environment.apiBaseUrl}/getPRWithPRNoSAP?pr_no=`,
        CREATE_PR_FROM_SAP: `${environment.apiBaseUrl}/createPrFromSAP`,
        UPDATE_PO_NOTIFICATION:`${environment.apiBaseUrl}/updatePoNotification`,
        RFQ : {
            CREATE : `${environment.apiBaseUrl}/createRfq`,
            UPDATE : `${environment.apiBaseUrl}/updateRfqDetail`,
            FETCH_RFQ_SUMMARY_LIST : `${environment.apiBaseUrl}/getAllRFQTemplate`,
            FETCH_RFQ_DETAILS : `${environment.apiBaseUrl}/getAllRFQwithData?id=`,
            FETCH_RFQ_PRID : `${environment.apiBaseUrl}/getAllRFQwithData`, 
            DELETE_SUPPLIER_FROM_RFQ : `${environment.apiBaseUrl}/deleteSupplierFromQuotation`,
            TEMPLATE : `${environment.apiBaseUrl}/upload_template`,
            DELETE_RFQ : `${environment.apiBaseUrl}/deleteRFQ`,
            FETCH_ATTACHMENT : `${environment.apiBaseUrl}/rfq_attachment_details`,
            DOWNLOAD_ATTACHMENT : `${environment.apiBaseUrl}/download_rfq_attchment`,
            DELETE_ATTACHMENT : `${environment.apiBaseUrl}/rfq_attachement`,
            UPLOAD_ATTACHMENT : `${environment.apiBaseUrl}/rfq_attachement`,
            UPDATE_QUOTATION_STATUS : `${environment.apiBaseUrl}/updateQuotationStatus`,
            FETCH_VENDOR_DATA: `${environment.apiBaseUrl}/getListofVendors`,
            ADD_VENDOR:`${environment.apiBaseUrl}/addNewVendorToRfq`,
            ADD_UNREGISTERED_VENDOR:`${environment.apiBaseUrl}/sendRfqToUnregisteredVendor`,
            FETCH_VENDOR_RFQ_DETAILS:`${environment.apiBaseUrl}/getAllRFQwithData?id=`
        },
        QES : {
            SAVE_BASIC_INFORMATION : `${environment.apiBaseUrl}/saveQESBasicInfo`,
            FETCH_BASIC_INFORMATION : `${environment.apiBaseUrl}/fetchQESBasicInfo?`,
            FETCH_SINGLE_SOURCE_JUSTIFICATION : `${environment.apiBaseUrl}/fetchQESSingleSourceJustification?`,
            FETCH_ADDITIONAL_EVALUATION : `${environment.apiBaseUrl}/fetchQESAdditionalEvaluationDetails?`,
            FETCH_QES_ATTACHMENTS : `${environment.apiBaseUrl}/fetchAllQESAttachments?`,
            FETCH_RFQ_ATTACHMENTS : `${environment.apiBaseUrl}/fetchAllQESAttachmentsFromRFQ?`,
            SAVE_SINGLE_SOURCE_JUSTIFICATION : `${environment.apiBaseUrl}/saveOrUpdateQESSingleSourceJustification`,
            SAVE_ADDITIONAL_EVALUATION_DETAILS : `${environment.apiBaseUrl}/saveOrUpdateQESAdditionalEvaluationDetails`,
            SAVE_BASIC_VENDOR_DETAILS : `${environment.apiBaseUrl}/saveOrUpdateQESVendorDetails`,
            SAVE_ADDITIONAL_COST_DETAILS : `${environment.apiBaseUrl}/saveOrUpdateQESAdditionalCostDetails`,
            FETCH_BASIC_VENDOR_DETAILS: `${environment.apiBaseUrl}/fetchAllQESVendorDetails`,
            FETCH_QES_ADDITIONAL_COST: `${environment.apiBaseUrl}/fetchQESAdditionalCostDetails?`,
            // FETCH_QUOTED_VENDORS: `${environment.apiBaseUrl}/getQuotedVendorListForQES?`,
            FETCH_QUOTED_VENDORS_LIST: `${environment.apiBaseUrl}/fetchQuatationAcceptedVendors`,
            SUBMIT_QES: `${environment.apiBaseUrl}/submitQES?`,
            FETCH_QES_PREPOLUATE_DATA: `${environment.apiBaseUrl}/getQesAutopoulatevalues?`,
            ATTACHMENTS: {
                UPLOAD_ATTACHMENT: `${environment.apiBaseUrl}/uploadQESAttachment?`,
                DELETE_ATTACHMNET: `${environment.apiBaseUrl}/deleteQESAttachment?`,
                DOWNLOAD_ATTACHMENT: `${environment.apiBaseUrl}/fetchQESAttachmentById?id=`,
                DOWNLOAD_RFQ_ATTACHMENT: `${environment.apiBaseUrl}/fetchAllQESAttachmentsFromRFQ?`,
            },
            APPROVERS: {
                FETCH_LIST_OF_APPROVERS: `${environment.apiBaseUrl}/fetchAllQESApprovers?`,
                FETCH_APPROVER_DETAILS: `${environment.apiBaseUrl}/fetchAllQESApprovalDetails?`,
                FETCH_QES_MASTER_DATA:`${environment.apiBaseUrl}/fetchQesMasterData`
            },
            MAP_PO_NUMBER_IN_QES:`${environment.apiBaseUrl}/mapPoNumberInQES`
        },
        SUPPLIER_COMMUNICATION : {
            ANALYZE_RESPONSE : `${environment.apiBaseUrl}/analyseSupplierResponse`
        },
        NEGOTIATIONS : {
            CREATE : `${environment.apiBaseUrl}/createNegotiations`,
            UPDATE : `${environment.apiBaseUrl}/updateNegotiation`,
            UPDATEONBEHALFOF: `${environment.apiBaseUrl}/onBehalfOfSupplierUpdateNegotiationByBuyer`,
        }
    },
    PO_BUYER : {
        PO_CONFIRMATION : `${environment.apiBaseUrl}/poConfirmation`,
        PO_FILE : `${environment.apiBaseUrl}/poFile`,
    },
    // PROFILE : {
    //     User : `${environment.apiBaseUrl}/user-profile`,
    //     // DELETE_ADDRESS : `${environment.apiBaseUrl}/delete-address`,
    // },
    ADMIN : {
        USER : `${environment.apiBaseUrl}/user-profile`,
        UPDATE_USER : `${environment.apiBaseUrl}/user-profile-update`,
        GET_DIVISION : `${environment.apiBaseUrl}/getDivision`,
        CHECK_FP_APPROVAL : `${environment.apiBaseUrl}/checkApprovals`,
        SEND_APPROVER : `${environment.apiBaseUrl}/sendForFPApproval`,
        USER_GID : `${environment.apiBaseUrl}/user-profile-gid`,
        DIVISION : `${environment.apiBaseUrl}/adminDivision`,
        PLANT_CODE : `${environment.apiBaseUrl}/adminPlantCode`,
        COMPANY_CODE : `${environment.apiBaseUrl}/adminCompanyCode`,
        ESN : `${environment.apiBaseUrl}/adminEsn`,
        CURRENCY : `${environment.apiBaseUrl}/currencyDetails`,
        WBSELEMENTBALANCE:`${environment.apiBaseUrl}/getWbsElementBalance`,
        ITRACER_USER : `${environment.apiBaseUrl}/getUserDetailsfromItracer`,
        APPROVER:`${environment.apiBaseUrl}/fetchPOApproverstablebygid`,
        THRESHOLD:`${environment.apiBaseUrl}/fetchPOApproverstableforcode`,
        RELEASESTRATEGY:`${environment.apiBaseUrl}/fetchPOApproverstableforreleasestrategy`,
        UPLOAD_APPROVER:`${environment.apiBaseUrl}/uploadpoApproverGID`,
        UPLOAD_THRESHOLD:`${environment.apiBaseUrl}/poapproverlistbythresoldandcode`,
        UPLOAD_CURRENCY:`${environment.apiBaseUrl}/currencyDetails`,
        GET_CURRENCY:`${environment.apiBaseUrl}/currencyDetails`,
        UPLOAD_PLANTMASTER:`${environment.apiBaseUrl}/plantCompanyMaster`,
        GET_PLANTMASTER:`${environment.apiBaseUrl}/plantCompanyMaster`,
        UPLOAD_RELEASESTRATEGY:`${environment.apiBaseUrl}/uploadmasterPOforApprovers`,
        GET_QES_MASTER_APPROVER_DATA:`${environment.apiBaseUrl}/qesMasterApproverData`,
        GET_QES_RELEASE_CODE:`${environment.apiBaseUrl}/qesReleaseCode`,
        GET_QES_THRESHOLD:`${environment.apiBaseUrl}/qesThreshold`,
        ESN_SERVICE:`${environment.apiBaseUrl}/serviceEsn`,
        PAYMENT_TERM_KEY:`${environment.apiBaseUrl}/paymentTerms`,
        EHS_UPLOAD:`${environment.apiBaseUrl}/vendorESHMaster`,
        PACKING_CODE:`${environment.apiBaseUrl}/packingCode`,
        PARTNER_CODE:`${environment.apiBaseUrl}/partnerCode`,
        SHIPPING_CODE:`${environment.apiBaseUrl}/shippingCode`,
        CONF_CONTROL:`${environment.apiBaseUrl}/confCtrl`,
        YA_PARTNER:`${environment.apiBaseUrl}/yaPartner`,
        TAX_CODE:`${environment.apiBaseUrl}/taxcode`,
        CLAUSE:`${environment.apiBaseUrl}/clause`,
        DOC_TYPE:`${environment.apiBaseUrl}/documentType`,
        COND_TYPE:`${environment.apiBaseUrl}/conditionType`,
        GBK:`${environment.apiBaseUrl}/GBK`,
        UPDATE_VENDOR_NOTIFICATION:`${environment.apiBaseUrl}/updateVendorPoNotification`,
        GET_VENDOR_NOTIFICATION:`${environment.apiBaseUrl}/getVendorNotificationDetails?id=`
    },

    ROLE : `${environment.apiBaseUrl}/fetch/role-with-gid`,
    ROLE_GID : `${environment.apiBaseUrl}/getUserRolewithGID`,
    VENDOR_LOGIN : `${environment.apiBaseUrl}/vendor_login`,
    FETCH_RC : `${environment.apiBaseUrl}/fetchBuyerContractData`,
    UPLOAD_RC : `${environment.apiBaseUrl}/buyer-contract`,
    DELETE_RC : `${environment.apiBaseUrl}/delete-buyer-contract?`,
    QES_APPROVER: {
        GET_ALL_PR : `${environment.apiBaseUrl}/getQESDetailsByApprover`,
        UPDATE_QES : `${environment.apiBaseUrl}/updateQESApprovals?`,
        CREATE_PO: `${environment.apiBaseUrl}/editPRDataForPOCreation?`
    },
    PO_CREATE: {
        GET_DOCUMENT_TYPE: `${environment.apiBaseUrl}/documentType`,
        GET_PO_SHIPPING_CODE: `${environment.apiBaseUrl}/shippingCode`,
        GET_PO_PACKING_CODE: `${environment.apiBaseUrl}/packingCode`,
        GET_PO_CONDITION_TYPE: `${environment.apiBaseUrl}/conditionType`,
        GET_PO_PARTNER_CODE: `${environment.apiBaseUrl}/partnerCode`,
        GET_PO_CONF_CTRL: `${environment.apiBaseUrl}/confCtrl`,
        GET_PO_CLAUSE: `${environment.apiBaseUrl}/clause`,
        GET_PO_YA_PARTNER: `${environment.apiBaseUrl}/yaPartner`,
        GET_PO_GBK: `${environment.apiBaseUrl}/GBK`,
        FETCH_APPROVER_DETAILS: `${environment.apiBaseUrl}/getPOApproverDetails`,
        CREATE_PO: `${environment.apiBaseUrl}/createManualPO`,
        CHANGE_PO:`${environment.apiBaseUrl}/poAmendment`,
        CREATE_AUTO_PO:`${environment.apiBaseUrl}/createPO`,
        CREATE_RC_PO: `${environment.apiBaseUrl}/createRCAutoPO`,
        FETCH_PO_LIST: `${environment.apiBaseUrl}/getAllPONumbersforPrID?`,
        FETCH_PO_DETAILS_FOR_BUYER: `${environment.apiBaseUrl}/getPoDetailsForBuyer?`,
        FETCH_PR_DETAILS_FOR_BUYER: `${environment.apiBaseUrl}/getLineItemDetailsForPO?prId=`,
        FETCH_PO_APPROVER_LIST: `${environment.apiBaseUrl}/get_po_approver_status?`,
        FETCH_PO_HISTORY: `${environment.apiBaseUrl}/getPOhistory`,
        FETCH_PO_VENDOR:`${environment.apiBaseUrl}/fetchBelowThresholdPoValues`,
        FETCH_APPROVER_LIST:`${environment.apiBaseUrl}/fetchPOApprovers`,
        FETCH_STORAGELOCATION:`${environment.apiBaseUrl}/getStoragelocation?plant=`,
        APPEND_LINEITEM:`${environment.apiBaseUrl}/fetchPrLineItemFromRfq?`
    },
    PO_UPDATE:{
        UPDATE_PO:`${environment.apiBaseUrl}/updatePORemark`
    }
}

export const UI_ROUTES = {
    LOGIN : `/login`,
    CREATE_PR : `/pr-initiator/create`,
    UPLOAD_PR : `/pr-initiator/upload`,
    BULK_PR_HISTORY :`/bulkPRhistory`,
    REFERENCE_PR : `/pr-initiator/reference`,
    UPDATE_PR : `/pr-initiator`,
    VIEW_PR : `/pr-initiator`,
    HOME : `/dashboard`,
    DASHBOARD: `/dashboard-charts`,
    USER_MANAGEMENT : `/userManagement`,
    EHS_HOME: `/ehs/home`,
    PO_HISTORY:`po-history/`,
    BUYER: {
        VALIDATE_INVALIDATE_REQUEST : '/buyer/price-validation',
        RFQ : '/buyer/rfq',
        IMPORT_PR : `/buyer/import-pr`,
        PO_CHANGES : `/buyer/po-changes`,
        PO_CONFIRM : `/buyer/po-confirm`,
        MARKET_RESULT : `/buyer/market-result`,
        SUPPLIER_ANALYSIS : `/buyer/supplier-analysis`,
        QES: `/buyer/quality-evaluation-sheet`
    },
    SUPPLIER : {
        HOME : '/supplier/dashboard',
        RFQ : '/supplier/rfq'
    },
    ADMIN : {
        HOME : '/admin/home'
    },
    PO_BUYER : {
        HOME : '/po-buyer/dashboard'  
    },
    QES: {
        VIEW_QES : '/qes-approver/quality-evaluation-sheet',
    },
    ACCESS_MODULE: {
        ACCESS_MODULE: '/login-module'
    }
}

export const UI_MESSAGES = {
    GENERIC_ERROR : `Something went wrong! Please try again later.`,
    NO_DATA : `No DATA FOUND.`,
    LOGOUT : `Logged Out successfully!`,
    PR : {
        DELETION : `Purchase Request deleted successfully!`,
        CREATE_DRAFT : `Purchase Request has been drafted successfully`,
        CREATE_PUBLISH : `Purchase Request has been published successfully`,
        UPDATION : `Purchase Request has been updated successfully`,
        FORWARD: `Purchase Request forwarded duccessfully`,
        EDIT_APPROVED_ERROR : `Cannot edit an approved Purchase Request!`,
        GENERIC_APPROVED_ERROR : `Cannot perform this operation on approved Purchase Request!`,
        PR_OWNER_ERROR : `Please check the selected PR Status to delete`
    },
    LINE_ITEM : {
        DELETION : `Line Item deleted successfully!`,
        CREATION : `Line Item added successfully!`,
    },
    RFQ : {
        TEMPLATE_UPLOAD : `RFQ File template uploaded successfully!`,
        DELETE_TEMPLATE : `RFQ File template deleted successfully!`,
        DELETE_TEMPLATE_ATTACHMENT : `RFQ File attachment deleted successfully!`,
    }
}

export const APP_VALIDATION_REGEX : Record<string, RegExp> = {
    ONLY_NUMBER_PATTERN : /^[0-9]\d*$/,
    EMAIL_PATTERN : /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
    FLOAT_NUMBER_PATTERN : /^(?!0\d)\d*(\.\d+)?$/,
    NO_NUMBER_PATTERN : /^([^0-9]*)$/,
    NO_SPECIAL_CHARACTERS : /^([a-zA-Z0-9]*)$/,
    ONE_CHARACTER : /^[a-zA-Z0-9]{0,1}$/,
    MAX_EIGHT_CHARACTER : /^[a-zA-Z0-9]{0,8}$/
}

export const ROLE_ROUTE_ACCESS : Record<RoleEnum | string, string[]> = {
    [RoleEnum.REQUESTER] : [UI_ROUTES.VIEW_PR,UI_ROUTES.CREATE_PR, UI_ROUTES.UPDATE_PR, UI_ROUTES.REFERENCE_PR, UI_ROUTES.UPLOAD_PR, UI_ROUTES.HOME,UI_ROUTES.PO_HISTORY,UI_ROUTES.BULK_PR_HISTORY],
    [RoleEnum.REPORTING_MANAGER] : [UI_ROUTES.VIEW_PR,UI_ROUTES.CREATE_PR, UI_ROUTES.UPDATE_PR, UI_ROUTES.REFERENCE_PR, UI_ROUTES.UPLOAD_PR, UI_ROUTES.HOME, UI_ROUTES.DASHBOARD],
    [RoleEnum.BUYER] : [UI_ROUTES.SUPPLIER.RFQ, UI_ROUTES.VIEW_PR,UI_ROUTES.REFERENCE_PR, UI_ROUTES.HOME,UI_ROUTES.UPDATE_PR, UI_ROUTES.BUYER.IMPORT_PR, UI_ROUTES.BUYER.MARKET_RESULT, UI_ROUTES.BUYER.QES, UI_ROUTES.BUYER.RFQ, UI_ROUTES.BUYER.VALIDATE_INVALIDATE_REQUEST, UI_ROUTES.BUYER.SUPPLIER_ANALYSIS],
    [RoleEnum.SUPPLIER] : [UI_ROUTES.VIEW_PR,UI_ROUTES.SUPPLIER.HOME, UI_ROUTES.SUPPLIER.RFQ, UI_ROUTES.DASHBOARD,UI_ROUTES.PO_HISTORY],
    [RoleEnum.ADMIN] : [UI_ROUTES.VIEW_PR,UI_ROUTES.ADMIN.HOME,UI_ROUTES.DASHBOARD],
    [RoleEnum.QES_APPROVER] : [UI_ROUTES.VIEW_PR,UI_ROUTES.CREATE_PR, UI_ROUTES.UPDATE_PR, UI_ROUTES.REFERENCE_PR, UI_ROUTES.UPLOAD_PR, UI_ROUTES.HOME, UI_ROUTES.PO_HISTORY],
    [RoleEnum.PO_BUYER] : [UI_ROUTES.VIEW_PR,UI_ROUTES.PO_BUYER.HOME],
    [RoleEnum.EHS_MANAGER] : [UI_ROUTES.EHS_HOME],
    [RoleEnum.FACTORY_PROCUREMENT] : [UI_ROUTES.VIEW_PR,UI_ROUTES.HOME,UI_ROUTES.BUYER.VALIDATE_INVALIDATE_REQUEST,UI_ROUTES.BUYER.SUPPLIER_ANALYSIS,UI_ROUTES.PO_HISTORY]
}